/* RESPONSIBLE TEAM: team-growth-opportunities */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import Route from '@ember/routing/route';
import { PRICING_5_X_EARLY_STAGE_SOLUTION_ID } from 'embercom/lib/billing';

export default Route.extend({
  beforeModel(transition) {
    let queryParams = Object.assign(transition.to.queryParams || {}, {
      solution_id: PRICING_5_X_EARLY_STAGE_SOLUTION_ID,
    });
    this.replaceWith('signup.teams.index', {
      queryParams,
    });
  },
});
